module.exports = __webpack_public_path__ + "static/media/TICKETFINDER HEADER_614x500.36777d9c.jpg";